import './copyLink.scss'
import { Toast } from '../toast'
import clsx from 'clsx'
import { useCopyToClipboard } from '@/shared/hooks'
import { CopyTextIcon } from '@/shared/assets'

interface CopyLinkProps {
    text?: string
    className?: string
    displayCopyIcon?: boolean
    shortenUrl?: boolean
}

export const CopyLink = ({
    text = '',
    className,
    displayCopyIcon,
    shortenUrl = true,
}: CopyLinkProps) => {
    const { copy, toastVisible, toastMessage, hideToast } = useCopyToClipboard()

    const preparedText = text && URL.canParse(text) ? new URL(text).href : text

    const handleCopy = () => {
        copy(preparedText)
    }

    return (
        <>
            {!displayCopyIcon ? (
                <>
                    <span
                        className={clsx(
                            'copy-text truncate text-ellipsis',
                            className
                        )}
                        onClick={handleCopy}
                        title="Нажмите, чтобы скопировать"
                    >
                        {shortenUrl
                            ? preparedText.replace(/^https?:\/\//, '')
                            : preparedText}
                    </span>
                    <Toast
                        message={toastMessage}
                        visible={toastVisible}
                        onClose={hideToast}
                        greenSwooshIcon={true}
                    />
                </>
            ) : (
                <div
                    className={clsx('copy-link-container', className)}
                    onClick={handleCopy}
                    title="Click to copy"
                >
                    <span className="copy-link-text truncate text-ellipsis">
                        {shortenUrl
                            ? preparedText.replace(/^https?:\/\//, '')
                            : preparedText}
                    </span>
                    <img
                        src={CopyTextIcon}
                        alt="Copy Icon"
                        className="copy-icon"
                    />
                    <Toast
                        message={toastMessage}
                        visible={toastVisible}
                        onClose={hideToast}
                        greenSwooshIcon={true}
                    />
                </div>
            )}
        </>
    )
}
